/**
 * Permet d'ajouter l'indicatif du pays devant le numéro de téléphone
 * @param phoneNumber Numéro de téléphone
 * @param countryCode Indicatif du pays (33 par défaut, France)
 */
export const addCountryCode = (phoneNumber?: string, countryCode = '33') => {
  return phoneNumber?.trim().replace(/^0/, `+${countryCode}`);
};
